import React from 'react'
import PromotionsListContainer from '../components/promotions/PromotionsListContainer'

const PromotionsListScreen = props => <PromotionsListContainer {...props} />

export default PromotionsListScreen
